// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import apiRequest from '@src/utility/BackendRequest'

export const toggleEditModal = createAsyncThunk('appUsers/toggleEditModal', async val => {
  return val
})

export const getData = createAsyncThunk('appUsers/getData', async params => {
  const response = await apiRequest.get('/users', {params})
  return {
    params,
    data: response.data.results,
    totalPages: response.data.totalPages
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async (user, { dispatch }) => {
  dispatch(toggleEditModal(true))
  return user
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  // await dispatch(getAllData())
  dispatch(toggleEditModal(true))
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch }) => {
  // await axios.delete('/apps/users/delete', { id })
  // await dispatch(getData(getState().users.params))
  // alert(id)
  await apiRequest.delete(`/users/${id}`)
  await dispatch(getData())
  return id
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    editModalOpen: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.totalPages = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(toggleEditModal.fulfilled, (state, action) => {
        state.editModalOpen = action.payload
      })
  }
})

export default appUsersSlice.reducer
